import React, { useEffect, useRef } from 'react';
import { PiFileXls } from 'react-icons/pi';
import { MdOutlineAttachEmail } from 'react-icons/md';

import { Link } from 'react-router-dom';
import CurrencySelect from '~/CurrencySelect';

interface ProductGroupDownloadPopoverProps {
	anchorRef: React.RefObject<HTMLElement | null>;
	currency: string | null;
	onProductsExport(): void;
	onProductsEvidenceExport(): void;
	onCzMaxPriceExport(): void;
	onClose(): void;
}

export function ProductGroupDownloadPopover({
	anchorRef,
	currency,
	onProductsExport,
	onProductsEvidenceExport,
	onCzMaxPriceExport,
	onClose,
}: ProductGroupDownloadPopoverProps) {
	const popoverRef = useRef<HTMLDivElement>(null);

	const handleClickOutside = (event: MouseEvent) => {
		const target = event.target as Node;

		if (
			popoverRef.current &&
			!popoverRef.current.contains(target) &&
			anchorRef.current &&
			!anchorRef.current.contains(target)
		) {
			onClose();
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div
			ref={popoverRef}
			data-testid='popover'
			className='absolute left-0 mt-0.5 w-72 bg-white rounded border border-gray-300 shadow-lg z-20'
		>
			<span className='absolute -top-[5px] left-2.5 w-2 h-2 bg-white border-t border-l border-gray-300 rounded-sm rotate-45 z-[-1]'></span>
			<div className='flex flex-col overflow-hidden rounded px-3.5 pt-2 pb-3.5'>
				<div className='flex justify-between items-center mb-px'>
					<h3 className='text-lg text-gray-600 font-semibold tracking-wide'>Choose export:</h3>
					<Link
						to='/help#export'
						className='text-[12px] text-cPurple-600 underline underline-offset-2 transition-colors hover:underline hover:text-black'
					>
						export info
					</Link>
				</div>
				<p className='mb-3 text-gray-500 leading-tight text-[12px]'>
					Currency conversion rates settings from list details are used in the export.
				</p>
				<div className='flex flex-row gap-x-3'>
					<div className='w-1/2'>
						<button
							onClick={onCzMaxPriceExport}
							className='relative flex items-center justify-start w-full pl-1.5 pr-2 h-7 rounded border border-cPurple-400 text-cPurple-600 font-semibold leading-4 text-[12px] bg-cPurple-100 bg-opacity-20 cursor-pointer tracking-wide transition-colors hover:bg-cPurple-600 hover:bg-opacity-100 hover:border-cPurple-600 hover:text-white'
						>
							<PiFileXls className='mr-1 w-[18px] h-[18px]' />
							CZ Max Price
						</button>
					</div>
					<div className='w-1/2'>
						<button
							onClick={onProductsEvidenceExport}
							className='relative flex items-center justify-start w-full pl-1.5 pr-2 h-7 rounded border border-blue-400 text-blue-600 font-semibold leading-4 text-[12px] bg-blue-100 bg-opacity-60 cursor-pointer tracking-wide transition-colors hover:bg-blue-600 hover:bg-opacity-100 hover:border-blue-600 hover:text-white'
						>
							<MdOutlineAttachEmail className='relative top-px mr-1.5 w-[18px] h-[18px]' />
							Evidence
						</button>
					</div>
				</div>
				<div className='relative w-full h-px my-3.5 bg-gray-200'>
					<span className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-[11px] text-gray-500'>
						or
					</span>
				</div>
				<div className='flex flex-row items-center justify-between gap-x-2'>
					<div className='w-[70px] h-[34px] grow-0 shrink-0'>
						<CurrencySelect
							excludeSourcePrice
							currentCurrency={currency}
							id='download-popover-currency-select'
							//onChange={(currency) => this.setState({ currency })}
							// eslint-disable-next-line no-console
							onChange={(currency) => console.log('sadasd')}
						/>
					</div>
					<button
						onClick={onProductsExport}
						className='relative flex items-center justify-start w-full pl-1.5 pr-2 h-7 rounded border border-cPurple-400 text-cPurple-600 font-semibold leading-4 text-[12px] bg-cPurple-100 bg-opacity-20 cursor-pointer tracking-wide transition-colors hover:bg-cPurple-600 hover:bg-opacity-100 hover:border-cPurple-600 hover:text-white'
					>
						<PiFileXls className='mr-1 w-[18px] h-[18px]' />
						Products data
					</button>
				</div>
			</div>
		</div>
	);
}
